import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import './Footer.scss';

import { TestMetadata } from '../types';

export interface FooterProps {
  /** if footer should be fixed to bottom of screen */
  isSticky?: boolean;
  /** Pass in children to override default */
  children?: ReactNode;
  /** Class name for content block container */
  className?: string;
  // Test IDs for component sections
  testMetadata?: {
    footerContainer?: TestMetadata;
    termsOfUse?: TestMetadata;
    privacyPolicy?: TestMetadata;
    support?: TestMetadata;
  };
}

const Footer: FC<FooterProps> = ({
  isSticky = true,
  children,
  testMetadata = {
    footerContainer: { 'data-testid': 'footerContainer' },
    termsOfUse: { 'data-testid': 'termsOfUse' },
    privacyPolicy: { 'data-testid': 'privacyPolicy' },
    support: { 'data-testid': 'support' },
  },
  className,
}) => {
  return (
    <div
      className={classNames(
        'sb-footer',
        {
          'sb-footer_sticky': isSticky,
        },
        className,
      )}
      {...testMetadata?.footerContainer}
    >
      {children ? (
        children
      ) : (
        <div>
          Copyright © DEE Technology - All Rights Reserved |{' '}
          <span className="sb-footer__terms-privacy">
            <a
              href="http://disneytermsofuse.com/"
              target="_blank"
              rel="noopener noreferrer"
              {...testMetadata?.termsOfUse}
            >
              Terms of Use
            </a>{' '}
            |{' '}
            <a
              href="https://disneyprivacycenter.com/"
              target="_blank"
              rel="noopener noreferrer"
              {...testMetadata?.privacyPolicy}
            >
              Privacy Policy
            </a>{' '}
            |{' '}
          </span>
          <a
            href="https://issues.dmed.technology"
            target="_blank"
            rel="noopener noreferrer"
            {...testMetadata?.support}
          >
            Support
          </a>
        </div>
      )}
    </div>
  );
};

export default Footer;
